export interface ReviewData {
  quote: string;
  author: { icon?: string; name: string };
}

export const BrianReview: ReviewData = {
  author: { name: 'Brian O.' },
  quote: 'review_brian_quote',
};

export const PressReviewData: ReviewData[] = [
  {
    author: { icon: '/newsbrand_images/forbes.png', name: 'Forbes' },
    quote: 'review_forbes_quote',
  },
  {
    author: {
      icon: '/newsbrand_images/biz-insider.png',
      name: 'Business Insider',
    },
    quote: 'review_business_insider_quote',
  },
  {
    author: { icon: '/newsbrand_images/pcmag.png', name: 'PC Mag' },
    quote: 'review_pcmag_quote',
  },
  {
    author: { icon: '/newsbrand_images/engadget_logo.png', name: 'Engadget' },
    quote: 'review_engadget_quote',
  },
];
